import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IReportStrings extends LocalizedStringsMethods {
    isReportsText: string;
    isDateTxt: string;
    isTypeTxt: string;
    isProfileName: string;
    isTestScore: string;
    isTestThreshold: string;
    isAdminTxt: string;
    isSubName: string;
    isSubCity: string;
    isSubEmail: string;
    lsPrintTxt: string;
    lsDwnldTxt: string;
    isActionTxt: string;
    lsTotalTestTxt: string;
    isTestTagTxt: string;
}

let strings: IReportStrings;
export default strings = new LocalizedStrings({
    en: {     
        isReportsText: 'Tests',
        isAdditionalInformationText: 'Failed Tests and Baselines',
        isDateTxt: 'Date And Time',
        isTypeTxt: 'Score Type',
        isTestTagTxt: 'Test Type',
        isProfileName: 'Profile Name',
        isTestScore: 'Score',
        isTestThreshold: 'Threshold',
        isAdminTxt: 'Administrator',
        isUsernameTxt: 'Username',
        isSubName: 'Organization Name',
        isSubCity: 'Organization Location',
        isSubEmail: 'Organization Email',
        lsPrintTxt: 'Print',
        lsDwnldTxt: 'Download',
        isActionTxt: 'Action',
        lsTotalTestTxt: 'Total {0} Reports',
        lsTestTypeExpl: 'Test is greater than 250,000 or Baseline test is above the community average',
        lsCSVDisplayedProfile: 'CSV (as displayed)',
        lsCSVAllProfile: 'CSV (all profile info)'
    },
    es: {
        isReportsText: 'Pruebas',
        isAdditionalInformationText: 'Pruebas fallidas y líneas base',
        isDateTxt: 'Date And Time',
        isTypeTxt: 'Score Type',
        isTestTagTxt: 'Test Type',
        isProfileName: 'Nombre de perfil',
        isTestScore: 'Puntuación',
        isTestThreshold: 'Límite',
        isAdminTxt: 'Administrador',
        isUsernameTxt: 'Nombre de usuario',
        isSubName: 'Nombre de la organización',
        isSubCity: 'Ubicación de la organización',
        isSubEmail: 'Correo electrónico de la organización',
        lsPrintTxt: 'Impresión',
        lsDwnldTxt: 'Descargar',
        isActionTxt: 'Acción',
        lsTotalTestTxt: 'Total de {0} informes',
        lsTestTypeExpl: 'La prueba es superior a 250.000 o la prueba de \
                            referencia está por encima del promedio de la comunidad',
        lsCSVDisplayedProfile: 'CSV (como se muestra)',
        lsCSVAllProfile: 'CSV (toda la información del perfil)'
    }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/reports/string.table.tsx